import React from "react";
import Select from "react-select";

interface Farmer {
  farmer_id: any;
  farmer_name: string;
  id?: any;
}

interface DynamicSelectProps {
  FarmerID: any;
  dataListFarmer?: Farmer[]; // تغییر به optional
  onChange: (selected: any) => void;
  setMainIDfarmer?: (id: any) => void;
  onInputChange?: (inputValue: string) => void;
  inputValue?: string;
  placeholder?: string;
  noOptionsMessage?: string | (() => string);
  loadingMessage?: string | (() => string);
  className?: string;
  classNamePrefix?: string;
  maxMenuHeight?: number;
  isSearchable?: boolean;
  menuPortalTarget?: HTMLElement;
  styles?: any;
}

const DynamicSelect: React.FC<DynamicSelectProps> = ({
  FarmerID,
  dataListFarmer = [],
  setMainIDfarmer,
  onChange,
  onInputChange,
  inputValue = "",
  placeholder = "جستوجو...",
  noOptionsMessage = "داده‌ای دریافت نشد",
  loadingMessage = "در حال بارگذاری...",
  className = "w-full my-react-select-container dark:bg-gray-100  dark:text-white",
  classNamePrefix = "my-react-select",
  maxMenuHeight = 300,
  isSearchable = true,
  menuPortalTarget = typeof document !== "undefined"
    ? document.body
    : undefined,
  styles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (base: any, state: any) => ({
      ...base,
      backgroundColor: "inherit",
      boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
    }),
    option: (base: any, state: any) => ({
      ...base,
      color: "inherit",
      "&:hover": {
        backgroundColor: "#2684FF",
      },
    }),
  },
}) => {
  // تبدیل داده‌ها به فرمت مورد نیاز react-select با حفاظت کامل در برابر null
  const options = React.useMemo(() => {
    return (dataListFarmer || []).map((farmer) => ({
      value: farmer?.farmer_id ?? "",
      label: String(farmer?.farmer_name || "بدون نام"), // اطمینان از string بودن
      mainIDfarmer: farmer?.id,
    }));
  }, [dataListFarmer]);

  // محاسبه مقدار انتخاب شده با حفاظت کامل
  const selectedValue = React.useMemo(() => {
    if (FarmerID === null || FarmerID === undefined || !options.length) {
      return null;
    }
  }, [FarmerID, options]);
  console.log(FarmerID);

  // تابع filterOption سفارشی برای جلوگیری از خطا
  const filterOption = (option: any, rawInput: string) => {
    const input = rawInput?.replace(/\s+/g, "").toLowerCase() || "";
    const label = String(option?.label || "")
      .replace(/\s+/g, "")
      .toLowerCase();
    return label.includes(input);
  };

  return (
    <Select
      value={selectedValue}
      options={options}
      styles={styles}
      menuPortalTarget={menuPortalTarget}
      onChange={(selected) => {
        onChange(selected?.value ?? null);
        setMainIDfarmer?.(selected?.mainIDfarmer);
      }}
      onInputChange={onInputChange}
      inputValue={inputValue}
      placeholder={placeholder}
      noOptionsMessage={() =>
        typeof noOptionsMessage === "function"
          ? noOptionsMessage()
          : noOptionsMessage
      }
      loadingMessage={() =>
        typeof loadingMessage === "function" ? loadingMessage() : loadingMessage
      }
      className={className}
      classNamePrefix={classNamePrefix}
      maxMenuHeight={maxMenuHeight}
      isSearchable={isSearchable}
      getOptionLabel={(option) => String(option?.label || "")}
      getOptionValue={(option) => String(option?.value ?? "")}
      filterOption={filterOption} // اضافه کردن فیلتر سفارشی
    />
  );
};

export default DynamicSelect;
